import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { Chip, ChipProps } from "@mui/material";
import React from "react";
import { cn } from "../../../helpers/cn";

export interface IClickableChip extends ChipProps {
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  isSelected?: boolean;
  id?: string;
  label: string;
  icon?: React.ReactElement;
  endIcon?: JSX.Element;
}

export const ClickableChip = ({
  label,
  icon,
  onClick,
  endIcon,
  isSelected = false,
  id,
  className,
  sx,
}: IClickableChip) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors,
  );

  return (
    <Chip
      sx={{
        backgroundColor: isSelected
          ? componentColors.secondary.secondaryContainer
          : "transparent",
        color: isSelected
          ? componentColors.secondary.onSecondaryContainer
          : componentColors.surface.onSurfaceVariant,
        fontWeight: 500,
        borderColor: isSelected
          ? componentColors.secondary.secondaryContainer
          : componentColors.outline.outline,
        ...sx,
      }}
      className={cn(
        "rounded-[8px] cursor-pointer transition-all px-[2px] py-[18px] lg:px-[6px] lg:py-[20px]",
        className,
      )}
      label={label}
      icon={icon}
      deleteIcon={endIcon}
      onDelete={endIcon && onClick}
      onClick={onClick}
      variant="outlined"
      id={id}
    />
  );
};
